<template>
  <div class="nav-wrapper">
    <div class="experience-container">
      <div class="form-section">
        <div class="business-form">
          <BackButton @back="$emit('back')" />
          <h1 class="main-title">{{ $t("operatingAgreement.title") }}</h1>
          <p class="subtitle">{{ $t("operatingAgreement.subtitle") }}</p>

          <div class="operating-card">
            <h3 class="whatToKnow">
              {{ $t("operatingAgreement.whatToKnow") }}
            </h3>
            <ul class="benefits-list">
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("operatingAgreement.benefits.rules") }}</span>
              </li>
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("operatingAgreement.benefits.template") }}</span>
              </li>
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("operatingAgreement.benefits.access") }}</span>
              </li>
            </ul>

            <div class="operating-options">
              <label class="operating-option">
                <input
                  type="radio"
                  v-model="operatingAgreement"
                  value="add"
                  name="operating"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <div class="option-details">
                    <span class="option-text">{{
                      $t("operatingAgreement.options.add.text")
                    }}</span>
                    <span class="option-price">{{
                      $t("operatingAgreement.options.add.price")
                    }}</span>
                  </div>
                </div>
              </label>

              <label class="operating-option">
                <input
                  type="radio"
                  v-model="operatingAgreement"
                  value="none"
                  name="operating"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("operatingAgreement.options.none")
                  }}</span>
                </div>
              </label>
            </div>

            <button class="next-button" @click="handleNext">
              {{ $t("operatingAgreement.save") }}
            </button>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-content">
          <h2 class="info-title">{{ $t("operatingAgreement.infoTitle") }}</h2>
          <div class="video-container">
            <iframe
              src="https://www.youtube.com/embed/3lLCWiW0iBQ"
              title="Operating Agreement Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="video-iframe"
            ></iframe>
          </div>
          <h3 class="info-subtitle">
            {{ $t("operatingAgreement.infoSubtitle") }}
          </h3>
          <p class="info-text">
            {{ $t("operatingAgreement.description") }}
          </p>

          <div class="illustration-container">
            <img
              src="@/assets/operating-illustration.png"
              alt="Operating Agreement Illustration"
              class="business-illustration"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "./BackButton.vue";

export default {
  name: "OperatingAgreement",
  components: {
    BackButton,
  },
  data() {
    return {
      operatingAgreement: "add",
    };
  },
  methods: {
    handleNext() {
      this.$emit("next", {
        operatingAgreement: this.operatingAgreement,
      });
    },
  },
};
</script>

<style scoped>
@import "@/styles/CustomerBusiness.css";
</style>
